import { EXISTIERT_PERSONALNUMMER_IN_ANDEREM_STANDORT } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useExistiertPersonalnummerInAnderemStandort/graphql/queries';
import {
  Rotationsplan_ExistiertPersonalnummerInAnderemStandortQuery,
  Rotationsplan_ExistiertPersonalnummerInAnderemStandortQueryVariables,
} from '@/gql/graphql';
import { ApolloClient } from '@apollo/client';
import { TFunction } from 'i18next';
import * as Sentry from '@sentry/react';

export async function validatePersonalnummer(
  mitarbeiterId: string,
  standortId: string,
  apolloClient: ApolloClient,
  t: TFunction<'translation', undefined>,
) {
  try {
    const result = await apolloClient.query<
      Rotationsplan_ExistiertPersonalnummerInAnderemStandortQuery,
      Rotationsplan_ExistiertPersonalnummerInAnderemStandortQueryVariables
    >({
      query: EXISTIERT_PERSONALNUMMER_IN_ANDEREM_STANDORT,
      variables: {
        mitarbeiterId: mitarbeiterId,
        standortId: standortId,
      },
    });

    if (result.error) {
      return {
        message: t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.standort.personalnummerKonnteNichtValidiertWerden',
        ),
      };
    }

    return result.data.mitarbeiter_existiertPersonalnummerInAnderemStandort
      .existiertPersonalnummer
      ? {
          message: t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.standort.personalNummerNichtEindeutig',
          ),
        }
      : undefined;
  } catch (error) {
    Sentry.captureException(
      `Die Personalnummer von Mitarbeiter ${mitarbeiterId} in Standort ${standortId} konnte nicht validiert werden: ${error}`,
    );
    return {
      message: t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.standort.personalnummerKonnteNichtValidiertWerden',
      ),
    };
  }
}
